var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.15256e-7,
    y: 0.0237427,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(-0.042554 7.15256e-07 0.0237427)",
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9147 17.9217C21.5515 16.973 22.6518 15.2013 22.6518 13.1719L22.6518 10.844C22.6518 7.0778 19.5995 4.02393 15.8332 4.02393C12.0671 4.02393 9.01319 7.0778 9.01319 10.844L9.01319 13.3386L13.1704 13.3386L13.1704 13.5008C12.6657 13.6266 12.1883 13.8221 11.7503 14.0782C10.1135 15.027 9.01319 16.7987 9.01319 18.828L9.01319 21.156C9.01319 24.9221 12.0656 27.976 15.8318 27.976C19.5979 27.976 22.6518 24.9221 22.6518 21.156L22.6518 18.6613L18.4946 18.6613L18.4946 18.4991C18.9993 18.3733 19.4767 18.1778 19.9147 17.9217ZM17.1639 21.988C17.1639 22.723 16.5683 23.3187 15.8332 23.3187C15.0982 23.3187 14.5026 22.723 14.5026 21.988L14.5026 10.0119C14.5026 9.27691 15.0982 8.68128 15.8332 8.68128C16.5683 8.68128 17.1639 9.27691 17.1639 10.0119L17.1639 21.988Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.6527,
    height: 24,
    fill: "white",
    transform: "translate(9 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZro);
export default __webpack_public_path__ + "static/media/ZRO.148aa5829b849f00ae97d4fff7b71562.svg";
export { ForwardRef as ReactComponent };